
import {
getCartGoodsCount,
getCartList,
changeCartGoodNum,
orderPre,
sendBless,
exchangeCoupon
} from '../api/shopping-cart.js'
import Api from '../api.js'
import Vue from 'vue'
import Alert from 'vux/src/components/alert/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import {
isAlipayOrWechat
} from '../utils/common.js'

import deleteSlider from '../components/deleteTemplate.vue'


export default {
data() {
return {
uid: null, //用户id
rMobile: "", //收花人手机号
address: "", //收花人详细地址
purpose: "", //收花目的地
goods: [], //购物车中商品列表
hwcard: "", //是否有电子祝福卡(有的话下单时要检验是否填过祝福语)
addressId: null, //地址id(提交订单时需要用到)
coupons: [], //用户可用优惠券列表
rName: "", //收花人名称
rCity: "", //收花人所在城市
bookMobile: "", //备用手机号
imagesUrl: Api.imgUrl,
totalGoodsFee: 0, //商品价格总计
totalFreight: 0, //总运费价格
allChecked: false, //是否全选
showCoupon: false, //显示优惠券
discountPrice: 0, //折扣金额
showdiscountNum: true, //显示已选推荐优惠券
maxDiscountCouponId: 0, //可用优惠券id
showGiftCard: false, //是否显示祝福卡
giftCardContent: "", //祝福卡内容
giftCardGoodsTime: null, //祝福卡加入购物车时间
giftCardSenderName: "", //祝福卡发送人
giftCardSkuId: null, //祝福卡商品的skuid
giftIndex: null, //修改祝福卡的商品index
show: true,
shwoLoading: false, //加载中
newUaid: null, //选择了其他收花地址
couponCode: "",//兑换优惠券码
goodsType:0,//默认0  1  返回有经纬度的地址   0   返回所有地址
loadingPre:false,//去结算
}
},
directives: {
TransferDom
},
components: {
Alert,
Confirm,
Toast,
Loading,
deleteSlider
},
created() {

},
mounted: function() {
this.newUaid = this.GetQueryString("uaid");

this.getCartListFun();
},
methods: {
onCancel() {
console.log('on cancel')
},
onConfirm(msg) {
console.log('on confirm')
if (msg) {
alert(msg)
}
},
getCartListFun() {
let that = this;
that.shwoLoading = true;
let url = "";
if (that.newUaid != null) {
url = '/rest/cart/view?uaid=' + that.newUaid;
} else {
url = '/rest/cart/view';
}
getCartList(url).then(res => {
console.log("返回--------", res)
if (res.code == 1) {
that.uid = res.data.uid; 
that.rMobile = res.data.rMobile; 
that.address = res.data.address; 
that.purpose = res.data.purpose; 
that.goods = res.data.goods; 
that.hwcard = res.data.hwcard; 
that.addressId = res.data.addressId; 
that.coupons = res.data.coupons; 
that.rName = res.data.rName; 
that.rCity = res.data.rCity; 
that.bookMobile = res.data.bookMobile; 
that.rCityId = res.data.rCityId;
that.goodsType = res.data.goodsType;
console.log("that.rName----------", that.rName)
}
that.shwoLoading = false;
})
},

selectGoodFun: function(index) {
console.log("选择的商品index---------", index)

if (this.goods[index]) {
if (this.goods[index].check) {
this.goods[index].check = !this.goods[index].check;
} else {

Vue.set(this.goods[index], 'check', true);
}

console.log("库存不够----------")
if (this.goods[index].stockNumber < this.goods[index].number) {
this.goods[index].number = this.goods[index].stockNumber;

let time = this.goods[index].time;
let skuId = this.goods[index].skuId;
let formData = new FormData();
formData.append('goodsTime', time);
formData.append('number', this.goods[index].number);
formData.append('skuId', skuId);
changeCartGoodNum(formData).then(res => {

})
}


console.log("限购不够----------")
if (this.goods[index].perUserLimit > 0 && this.goods[index].number > this.goods[index].residueTimes) {
this.goods[index].number = this.goods[index].residueTimes;

let time = this.goods[index].time;
let skuId = this.goods[index].skuId;
let formData = new FormData();
formData.append('goodsTime', time);
formData.append('number', this.goods[index].number);
formData.append('skuId', skuId);
changeCartGoodNum(formData).then(res => {

})
}
}


this.totalGoodsFeeFun();
},


changeGoodNumFun: function(type, index) {
let that = this;

let cartNum = null;

if (type == "add") {

if (that.goods[index].number > 99) {
that.goods[index].number = 99;
goodsTime = that.goods[index].time;
cartNum = 99;
}

if (Number(that.goods[index].perUserLimit) > 0 && that.goods[index].number >= Number(that.goods[index].residueTimes)) {
this.$vux.toast.text('折扣价超过数量,前往商品详情页原价购买！', 'middle')
return;
}


if (that.goods[index].number < that.goods[index].stockNumber) {
that.goods[index].number++;
cartNum = that.goods[index].number;
} else {
this.$vux.toast.text('库存不足！', 'middle')
return;
}
} else if (type == "sub") {

if (that.goods[index].number <= 1) {

this.$vux.confirm.show({
title: '提示',
content: '您确定删除?',

onCancel() {
console.log("点击了取消")

},
onConfirm() {
let time = that.goods[index].time;
let skuId = that.goods[index].skuId;
let formData = new FormData();
formData.append('goodsTime', time);
formData.append('number', 0);
formData.append('skuId', skuId);
changeCartGoodNum(formData).then(res => {
if (res.code == 1) {
that.goods.splice(index, 1);
that.$vux.toast.text('已删除', 'middle')
} else {
that.$vux.toast.text(res.desc, 'middle')
}
})
}
})
} else {
that.goods[index].number--;
cartNum = that.goods[index].number;
}
} else {

if (that.goods[index].number > 99) {
that.goods[index].number = 99;
goodsTime = that.goods[index].time;
cartNum = 99;
} else {
cartNum = that.goods[index].number;
}
}

if (cartNum != null) {
let formData = new FormData();
formData.append('goodsTime', that.goods[index].time);
formData.append('number', cartNum);
formData.append('skuId', that.goods[index].skuId);
changeCartGoodNum(formData).then(res => {
if (res.code == 1) {} else {
that.$vux.toast.text(res.desc, 'middle')
}
})
}



that.totalGoodsFeeFun();
},

totalGoodsFeeFun: function() {
this.getTotalFee()


this.selCouponsFun();
},


getTotalFee:function(){
let totalGoodsFee = 0;
let totalFreight = 0; 

for (let item in this.goods) {
let goodFee = 0; 
let freight = 0; 

let extraGoodFee = 0;
if (this.goods[item].check == true) {
goodFee = Number(this.goods[item].salePrice);
freight = Number(this.goods[item].freight);
console.log("goodFee--------", goodFee)

for (let eItem in this.goods[item].extraGoods) {

if (this.goods[item].extraGoods[eItem].valid) {
extraGoodFee += Number(this.goods[item].extraGoods[eItem].goodsFee);
}
}
totalGoodsFee += (goodFee + extraGoodFee).toFixed(2) * this.goods[item].number; 
totalFreight += freight * this.goods[item].number
}

}
this.totalGoodsFee = totalGoodsFee.toFixed(2);
this.totalFreight = totalFreight;

console.log("商品总计--------", this.totalGoodsFee)
console.log("运费总计--------", this.totalFreight)
},

allCheckFun: function() {
for (let item in this.goods) {
if (this.goods[item].check) {

if (this.allChecked) {
this.goods[item].check = false;
} else {

if (this.goods[item].valid) {
this.goods[item].check = true;

console.log("库存不够----------")
if (this.goods[item].stockNumber < this.goods[item].number) {
this.goods[item].number = this.goods[item].stockNumber;

let time = this.goods[item].time;
let skuId = this.goods[item].skuId;
let formData = new FormData();
formData.append('goodsTime', time);
formData.append('number', this.goods[item].number);
formData.append('skuId', skuId);
changeCartGoodNum(formData).then(res => {

})
}
}

}
} else {


if (this.allChecked) {
Vue.set(this.goods[item], 'check', false);
} else {

if (this.goods[item].valid) {
Vue.set(this.goods[item], 'check', true);
if (this.goods[item].stockNumber < this.goods[item].number && this.goods[item].valid) {
this.goods[item].number = this.goods[item].stockNumber;

let time = this.goods[item].time;
let skuId = this.goods[item].skuId;
let formData = new FormData();
formData.append('goodsTime', time);
formData.append('number', this.goods[item].number);
formData.append('skuId', skuId);
changeCartGoodNum(formData).then(res => {

})
}
}
}

}
}
this.allChecked = !this.allChecked;

this.totalGoodsFeeFun();
},


selCouponsFun: function() {
this.maxDiscountCouponId = 0; 
console.log("优惠券选择")

let discountPrice = 0; 
let maxDiscount = 0; 
let selectIndex = -1; 

for (let item in this.coupons) {

if (this.coupons[item].type == 0) {

if (this.coupons[item].forGidList != null) {
let totalSalePrice = 0; 
let outNum = 0; 
for (let gitem in this.goods) {
if (this.goods[gitem].check == true && this.goods[gitem].useCoupon == true  && this.coupons[item].forGidList.indexOf(this.goods[gitem].spuId) >=
0) {
totalSalePrice += this.goods[gitem].salePrice * this.goods[gitem].number;
}
}

if (totalSalePrice >= this.coupons[item].orderQuota) {
discountPrice = this.coupons[item].value > totalSalePrice ? totalSalePrice : this.coupons[
item]
.value;
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
this.maxDiscountCouponId = this.coupons[item].couponId; 
selectIndex = Number(item);
this.discountPrice = discountPrice; 
}
}
} else {
let totalSalePrice = 0; 

for (let gitem in this.goods) {
if (this.goods[gitem].check == true && this.goods[gitem].useCoupon == true) {
totalSalePrice += this.goods[gitem].salePrice * this.goods[gitem].number;
}
}
if (totalSalePrice >= this.coupons[item].orderQuota) {
discountPrice = this.coupons[item].value > totalSalePrice ? totalSalePrice : this.coupons[
item]
.value;
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
this.maxDiscountCouponId = this.coupons[item].couponId; 
selectIndex = Number(item);
this.discountPrice = discountPrice; 
}
}
}


} else {

let totalSalePrice = 0;
for (let gitem in this.goods) {
if (this.goods[gitem].check == true && this.goods[gitem].useCoupon == true) {
totalSalePrice += this.goods[gitem].salePrice * this.goods[gitem].number;
}
}



if (this.coupons[item].forGidList != null) {
let outNum = 0; 
for (let i = 0; i < selectGoodId.length; i++) {
if (this.coupons[item].forGidList.indexOf(selectGoodId[i]) < 0) {
outNum++;
}
}
if (outNum <= 0) {

discountPrice = totalSalePrice * (1 - Number(this.coupons[item].value));

if (this.coupons[item].maxDiscount == 0) {

discountPrice = discountPrice > totalSalePrice ? totalSalePrice : discountPrice;
} else {

discountPrice = discountPrice > this.coupons[item].maxDiscount ? this.coupons[item].maxDiscount :
discountPrice;
}
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
this.maxDiscountCouponId = this.coupons[item].couponId; 
selectIndex = Number(item);
this.discountPrice = discountPrice; 
}
}
} else {


discountPrice = totalSalePrice * (1 - Number(this.coupons[item].value));

if (this.coupons[item].maxDiscount == 0) {

discountPrice = discountPrice > totalSalePrice ? totalSalePrice : discountPrice;
} else {

discountPrice = discountPrice > this.coupons[item].maxDiscount ? this.coupons[item].maxDiscount :
discountPrice;
}
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
this.maxDiscountCouponId = this.coupons[item].couponId; 
selectIndex = Number(item);
this.discountPrice = discountPrice; 
}
}


}
}



for (let i = 0; i < this.coupons.length; i++) {
if (this.coupons[i].check) {
this.coupons[i].check = false;
} else {
Vue.set(this.coupons[i], 'check', false)
}
}

if (selectIndex != -1) {
if (this.coupons[selectIndex].check) {
this.coupons[selectIndex].check = true;
} else {
Vue.set(this.coupons[selectIndex], 'check', true)
}
this.showdiscountNum = true; 
} else {

this.showdiscountNum = false;
this.discountPrice = 0;
}

},


showCouponFun: function() {

let totalSalePrice = 0;
for (let gitem in this.goods) {
if (this.goods[gitem].check == true && this.goods[gitem].useCoupon == true) {
totalSalePrice += this.goods[gitem].salePrice * this.goods[gitem].number;
}
}
if (totalSalePrice > 0) {

for (let item in this.coupons) {

if (this.coupons[item].available) {
this.coupons[item].available = false;
} else {
Vue.set(this.coupons[item], 'available', false)
}

if (this.coupons[item].forGidList != null) {
let totalSalePrice = 0; 
let outNum = 0; 
for (let gitem in this.goods) {
if (this.goods[gitem].check == true && this.goods[gitem].useCoupon == true && this.coupons[item].forGidList.indexOf(this.goods[gitem].spuId) >=
0) {
totalSalePrice += this.goods[gitem].salePrice * this.goods[gitem].number;
}
}

if (totalSalePrice >= this.coupons[item].orderQuota) {

if (this.coupons[item].type == 0) {
if (this.coupons[item].available) {
this.coupons[item].available = true;
} else {
Vue.set(this.coupons[item], 'available', true)
}
} else {

if (this.coupons[item].available) {
this.coupons[item].available = true;
} else {
Vue.set(this.coupons[item], 'available', true)
}
}
}
} else {

if (this.coupons[item].type == 0) {
if (totalSalePrice >= this.coupons[item].orderQuota) {
if (this.coupons[item].available) {
this.coupons[item].available = true;
} else {
Vue.set(this.coupons[item], 'available', true)
}
}
} else {

if (this.coupons[item].available) {
this.coupons[item].available = true;
} else {
Vue.set(this.coupons[item], 'available', true)
}
}
}


}
this.showCoupon = true;
} else {
this.$vux.toast.text('请先选择可用优惠券商品！', 'middle')

}
},


closeCouponFun: function() {
this.showCoupon = false;
},


changeCouponFun: function(index, available, check) {

if (!available) {
return;
}
if(check){
this.coupons[index].check = false;
this.maxDiscountCouponId = 0; 
this.discountPrice = 0;

this.getTotalFee();
return;
}



let oldItem = -1;
for (let item in this.coupons) {
if (this.coupons[item].check == true) {
oldItem = item;
}
}

let newItem = -1;

let discountPrice = 0;
let maxDiscount = 0



if (this.coupons[index].forGidList != null) {
let totalSalePrice = 0; 
let outNum = 0; 
for (let gitem in this.goods) {
if (this.goods[gitem].check == true && this.coupons[index].forGidList.indexOf(this.goods[gitem].spuId) >=
0) {
totalSalePrice += this.goods[gitem].salePrice * this.goods[gitem].number;
}
}
if (totalSalePrice >= this.coupons[index].orderQuota) {
discountPrice = this.coupons[index].value > totalSalePrice ? totalSalePrice : this.coupons[index].value;
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
this.maxDiscountCouponId = this.coupons[index].couponId; 
this.discountPrice = discountPrice; 


if (this.coupons[index].check) {
this.coupons[index].check = !this.coupons[index].check;
} else {
Vue.set(this.coupons[index], 'check', true)
}

newItem = index;
}
}
} else {


if (this.coupons[index].type == 0) {
if (this.totalGoodsFee >= this.coupons[index].orderQuota) {
discountPrice = this.coupons[index].value > this.totalGoodsFee ? this.totalGoodsFee : this.coupons[
index]
.value;
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
this.maxDiscountCouponId = this.coupons[index].couponId; 
this.discountPrice = discountPrice; 


if (this.coupons[index].check) {
this.coupons[index].check = !this.coupons[index].check;
} else {
Vue.set(this.coupons[index], 'check', true)
}

newItem = index;
}

}
} else {


discountPrice = this.totalGoodsFee * (1 - Number(this.coupons[index].value));

if (this.coupons[index].maxDiscount == 0) {

discountPrice = discountPrice > this.totalGoodsFee ? this.totalGoodsFee : discountPrice;
} else {

discountPrice = discountPrice > this.coupons[index].maxDiscount ? this.coupons[index].maxDiscount :
discountPrice;
}
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
this.maxDiscountCouponId = this.coupons[index].couponId; 
this.discountPrice = discountPrice; 


if (this.coupons[index].check) {
this.coupons[index].check = !this.coupons[index].check;
} else {
Vue.set(this.coupons[index], 'check', true)
}

newItem = index;
}
}
}


if (newItem != -1 && oldItem != -1) {
Vue.set(this.coupons[oldItem], 'check', false)
}
this.showdiscountNum = false; 

},


orderPreFun: function() {
if(this.loadingPre == true){
this.$vux.toast.text('结算中...', 'middle');
return;
}
let that = this;
let freight = 0; 
let joinCartTime = []; 
let gidListStr = "";
let noBlessing = false; 
for (let item in this.goods) {
if (this.goods[item].check == true) {
freight += Number(this.goods[item].freight) * Number(this.goods[item].number);
if (this.goods[item].hwcard == 1) {
if (this.goods[item].content == null || this.goods[item].content == "") {
noBlessing = true;
}
}
gidListStr += this.goods[item].spuId + ",";
joinCartTime.push(this.goods[item].time)
}
}

if (joinCartTime.length <= 0) {
this.$vux.toast.text('请选择商品！', 'middle');
return;
}

if (noBlessing) {
this.$vux.toast.text('请完整填写祝福卡内容和署名!', 'middle');
return;
}


if (this.addressId == null || this.addressId == "") {
this.$vux.toast.text('请选择收货地址!', 'middle');
return;
}



if (this.bookMobile == null || this.bookMobile == "") {
this.$vux.toast.text('请留下您订花人的电话，若收花时有问题，以便我们后期联系您沟通！', 'middle');
return;
}

this.loadingPre = true;

console.log("选择的商品列表-------",this.goods)

let params = {
addressId: this.addressId, //收花地址id
bookMobile: this.bookMobile, //订花人手机号
joinCartTime: joinCartTime, //要结算的购物车商品加入时间[1,2]
couponSn: this.maxDiscountCouponId, //优惠券ID
couponDiscountFee: this.totalToFixed(this.discountPrice), //优惠券抵扣金额
freight: freight.toFixed(2), //运费
orderFee: this.totalToFixed(this.totalGoodsFee - this.discountPrice + this.totalFreight), //订单金额
smart: "N", //是否小程序环境Y是,N否
payMethod: isAlipayOrWechat(), //支付方式：wx,alipay或者''
}
this.$store.state.preData = params; 
orderPre(params).then(res => {
this.loadingPre = false;
console.log("返回--------", res)
if (res.code == 1) {
this.$store.state.orderInfo = res.data;
this.$store.state.addressId = that.addressId;
this.$store.state.rCityId = that.rCityId;
this.$store.state.gidListStr = gidListStr;
this.$store.state.selectGdList = this.goods;
this.$router.push({
path: '/OrderCart',
query: {}
})
} else {
that.$vux.alert.show({
title: '提示',
content: res.desc,
onShow() {
console.log('Plugin: I\'m showing')
},
onHide() {
console.log('Plugin: I\'m hiding')
}
})
}
})
},


totalToFixed: function(total) {
if (total.toString().indexOf('.') > -1) {
let arr = total.toString().split('.');
console.log(arr,'arr')
let len = arr[1].length;
if (len > 0) {
return parseFloat(total).toFixed(2)
} else {
return total
}
} else {
return total
}
},



showGiftCardFun: function(content, skuId, time, senderName, index) {
this.showGiftCard = !this.showGiftCard;
this.giftCardContent = content; 
this.giftCardGoodsTime = time; 
this.giftCardSenderName = senderName; 
this.giftCardSkuId = skuId; 
this.giftIndex = index; 
},


sendBlessFun: function() {
let that = this;
if (that.giftCardContent == null || that.giftCardContent == "") {
that.$vux.toast.text("请填写祝福卡内容", 'middle');
return;
}

if (that.giftCardSenderName == null || that.giftCardSenderName == "") {
that.$vux.toast.text("请输入署名", 'middle');
return;
}

let formData = new FormData();
formData.append('goodsTime', that.giftCardGoodsTime); 
formData.append('content', that.giftCardContent); 
formData.append('senderName', that.giftCardSenderName); 
formData.append('skuId', that.giftCardSkuId); 
sendBless(formData).then(res => {
console.log("返回--------", res)
if (res.code == 1) {
that.showGiftCard = false;

that.goods[that.giftIndex].content = that.giftCardContent;
that.goods[that.giftIndex].senderName = that.giftCardSenderName

that.$vux.toast.text('祝福卡填写成功', 'middle', 20000)
} else {
that.$vux.toast.text(res.desc, 'middle')
}
})
},
closeGiftCardFun: function() {
this.showGiftCard = false;
},

stopFun: function() {

},

gotoGoodInfoFun: function(goodsDetailUrl) {


window.location.href = process.env.PAGEURL + "/goodDetails?gid=" + goodsDetailUrl;
},

gotoAddressFun: function() {
let currentUrl = process.env.PAGEURL;
this.$router.push({
path: '/addressList',
query: {
uaid: this.addressId,
type: 'cart',
goodsType:this.goodsType
}
})
},


addAddressFun: function() {
let currentUrl = process.env.PAGEURL;
let addressUrl = "";
if (process.env.NODE_ENV == "production") {
addressUrl = "https://my.reflower.com.cn/address/toAddressList"
} else {
addressUrl = "https://my-ce.reflower.com.cn/address/toAddressList";

}
location.href = addressUrl + "?type=cart&url=" + encodeURIComponent(currentUrl +
'/shoppingCart' + "&goodsType=" + this.goodsType);
},


GetQueryString: function(name) {
return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [,
""
])[1].replace(/\+/g, '%20')) || null
},

deleteItem: function(index) {
console.log("删除index--------", index);

let that = this;

this.$vux.confirm.show({
title: '提示',
content: '您确定删除?',

onCancel() {
console.log("点击了取消")

},
onConfirm() {
let time = that.goods[index].time;
let skuId = that.goods[index].skuId;
let formData = new FormData();
formData.append('goodsTime', time);
formData.append('number', 0);
formData.append('skuId', skuId);
changeCartGoodNum(formData).then(res => {
if (res.code == 1) {
that.goods.splice(index, 1);
that.$vux.toast.text('已删除', 'middle')
} else {
that.$vux.toast.text(res.desc, 'middle')
}
})
}
})
},

clearCouponCode(){
this.couponCode = ""
},

exchangeCouFn(){
let params = {
couponSn : this.couponCode
}
if(!this.couponCode){
this.$vux.toast.text('请输入优惠券码！', 'middle')
return
}
exchangeCoupon(params).then(res=>{
if(res.code == 1){
this.$vux.toast.text('兑换成功！', 'middle')
this.getCartListFun()
}

})
},
appointSpuIdsIndexOf:function(supid){
var appointSpuIds = [
"14925",
"14926",
"14936",
"14930",
"14931",
"14932",
"14924",
"14933",
"14934",
"14935",
"14927",
"14928",
"14929"
];
var num = 0;
for(var i = 0; i < appointSpuIds.length ; i++){
if(appointSpuIds[i] == supid){
num ++;
break;
}
}
if(num > 0){
return true;
}else{
return false
}
}
},
filters: {

dateFormat: function(dataStr) {
var time = new Date(dataStr);

function timeAdd0(str) {
if (str < 10) {
str = '0' + str;
}
return str
}
var y = time.getFullYear();
var m = time.getMonth() + 1;
var d = time.getDate();
var h = time.getHours();
var mm = time.getMinutes();
var s = time.getSeconds();
return y + '-' + timeAdd0(m) + '-' + timeAdd0(d);
},

strToFixed: function(num1, num2) {
let total = num1 * num2;
if (total.toString().indexOf('.') > -1) {
let arr = total.toString().split('.');
let len = arr[1].length;
if (len > 0) {
return parseFloat(total).toFixed(2)
} else {
return total
}
} else {
return total
}
},

strAddToFixed: function(total) {
console.log("total---------", total)
if (total.toString().indexOf('.') > -1) {
let arr = total.toString().split('.');
let len = arr[1].length;
console.log(total,'total-1')
if (len > 0) {
return parseFloat(total).toFixed(2)
} else {
return total
}
} else {
return total
}
}

}
}



// WEBPACK FOOTER //
// ./src/view/shopping-cart.vue